// extracted by mini-css-extract-plugin
module.exports = {"blocks":"PrivacyRating_blocks__3rsZL","block":"PrivacyRating_block__1Ncj6","block-inner":"PrivacyRating_block-inner___Vg6b","rating":"PrivacyRating_rating__17NXt"};